import { Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, PrimaryPaper } from '@atoms/layout';
import { DataGrid } from '@molecules/dataDisplay';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { ShiftsIcon } from '@atoms/icons';
import { useFacilitiesListColumns } from '../columns';
import { useEffect } from 'react';
import { useFacilitiesListStore } from '@libs/store/facilities/facilitiesListStore';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { FacilitiesFilters } from './filters';
import { useFacilitiesListFiltersStore } from '@libs/store/facilities';

type Props = {
  localizationSubset: string;
};
const DEFAULT_PAGE_SIZE = 10;
export function FacilitiesListPage({ localizationSubset }: Props) {
  const intl = useIntl();
  const { page, perPage, total, facilities, loadFacilities, loadingList } = useFacilitiesListStore();
  const { refreshTrigger } = useRefreshSyncStore();
  const { activeFilters } = useFacilitiesListFiltersStore();
  const loading = loadingList;

  useEffect(() => {
    loadFacilities(activeFilters, 1, DEFAULT_PAGE_SIZE);
  }, [loadFacilities, refreshTrigger, activeFilters]);


  return (
    <Box aria-label="FacilitiesSubpage" sx={{ height: '100%', width: '100%' }}>
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Stack spacing={2} sx={{ height: '100%', width: '100%' }}>
          <FacilitiesFilters loading={loading} localizationSubset={localizationSubset} />
          <DataGrid
            rows={facilities}
            loading={loading}
            rowHeight={64}
            columns={useFacilitiesListColumns(localizationSubset)}
            disableRowSelectionOnClick
            noRowsOverlay={
              <EmptyListPlaceholder
                icon={<ShiftsIcon active />}
                title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
                subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
              />
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: DEFAULT_PAGE_SIZE,
                },
              },
            }}
            onPaginationModelChange={(params) => {
              loadFacilities(activeFilters, params.page, params.pageSize);
            }}
            paginationModel={{
              pageSize: perPage,
              page: page,
            }}
            rowCount={total}
            pageSizeOptions={[DEFAULT_PAGE_SIZE, 20]}
          />
        </Stack>
      </PrimaryPaper>
    </Box>
  );
}
